import React from "react";

export default function DanceWithMeShadowMan() {
  return (
    <>
      <p class="c2">
        <span>
          <p>
            Who circles in the shadow’s light? - The veiled ones do, prepared to
            fight.
          </p>

          <p>
            Who taunts the Eyeless in the night? - The Aiel do, their hearts
            burn bright.
          </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>
            Dance with me, Shadowman, come and play! - Your dark blades fall,
            but we won’t sway.
          </p>
          <p>
            Dance with me, Eyeless, round and round - Until your lifeless form
            meets the ground.
          </p>
        </span>
      </p>
      <p class="c2">
        <span>
          [Verse 2]
          <p>
            Who drums the rhythm, fierce and low? - The veiled ones do, they own
            the flow.
          </p>
          <p>
            Who strikes the shadow, blow by blow? - The Aiel do, they lay it
            low.
          </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>
            Dance with me, Shadowman, come and play! - Your dark blades fall,
            but we won’t sway.
          </p>
          <p>
            Dance with me, Eyeless, round and round - Until your lifeless form
            meets the ground.
          </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>
            {" "}
            What do you fear, with your eyeless gaze? - Ooh the Aiel, we’re your
            grave!
          </p>

          <p>
            What do we seek, in this deadly game? - Honor and blood, a warrior’s
            name!
          </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>
            Dance with me, Shadowman, come and play! - Your dark blades fall,
            but we won’t sway.
          </p>
          <p>
            Dance with me, Eyeless, round and round - Until your lifeless form
            meets the ground.
          </p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>
            Who circles in the shadow’s light? - The veiled ones do, prepared to
            fight.
          </p>

          <p>
            Who ends the shadow’s deadly night? - The Aiel do, with hearts
            alight.
          </p>
        </span>
      </p>
    </>
  );
}
